import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "./styles/addPhoneForm.css";

export default function AddPhoneForm() {
  // Main form state
  const [formData, setFormData] = useState({
    name: '',
    brand: '',
    model: '',
    description: '',
    showInShop: true,
    memoryOptions: [{
      memory: '',
      colors: [{ color: '', bitrixId: '' }],
      price: '',
      discountedPrice: ''
    }]
  });

  // Edit form state
  const [formDataEdit, setFormDataEdit] = useState({
    name: '',
    brand: '',
    model: '',
    description: '',
    showInShop: true,
    memoryOptions: [{
      memory: '',
      colors: [{ color: '', bitrixId: '' }],
      price: '',
      discountedPrice: ''
    }]
  });

  // Media files
  const [photos, setPhotos] = useState([]);
  const [video, setVideo] = useState(null);
  const [photosEdited, setPhotosEdit] = useState([]);
  const [videoEdited, setVideoEdit] = useState(null);

  // Product management
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Fetch products from API
  const fetchProducts = async () => {
    try {
      const res = await axios.get('https://nts-center.ru/api/phones?admin=true');
      setProducts(res.data);
    } catch (err) {
      console.error('Error fetching products:', err);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // ========== MAIN FORM HANDLERS ==========
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleMemoryOptionChange = (index, field, value) => {
    const updated = [...formData.memoryOptions];
    updated[index] = { ...updated[index], [field]: value };
    setFormData(prev => ({ ...prev, memoryOptions: updated }));
  };

  const handleColorChange = (memoryIndex, colorIndex, field, value) => {
    const updated = [...formData.memoryOptions];
    const updatedColors = [...updated[memoryIndex].colors];
    updatedColors[colorIndex] = {
      ...updatedColors[colorIndex],
      [field]: value
    };
    updated[memoryIndex].colors = updatedColors;
    setFormData(prev => ({ ...prev, memoryOptions: updated }));
  };

  const addMemoryOption = () => {
    setFormData(prev => ({
      ...prev,
      memoryOptions: [
        ...prev.memoryOptions,
        { memory: '', colors: [''], price: '', discountedPrice: '' }
      ]
    }));
  };

  const removeMemoryOption = (index) => {
    const updated = formData.memoryOptions.filter((_, i) => i !== index);
    setFormData(prev => ({ ...prev, memoryOptions: updated }));
  };

  const addColorToMemory = (memoryIndex) => {
    const updated = [...formData.memoryOptions];
    updated[memoryIndex].colors.push({ color: '', bitrixId: '' });
    setFormData(prev => ({ ...prev, memoryOptions: updated }));
  };


  const removeColorFromMemory = (memoryIndex, colorIndex) => {
    const updated = [...formData.memoryOptions];
    updated[memoryIndex].colors = updated[memoryIndex].colors.filter((_, i) => i !== colorIndex);
    setFormData(prev => ({ ...prev, memoryOptions: updated }));
  };

  const handlePhotosChange = (e) => {
    const files = Array.from(e.target.files);
    const newPhotos = files.map(file => ({
      file,
      preview: URL.createObjectURL(file)
    }));
    setPhotos(newPhotos);
  };

  const handleVideoChange = (e) => {
    setVideo(e.target.files[0]);
  };

  // ========== EDIT FORM HANDLERS ==========
  const handleChangeEdit = (e) => {
    const { name, value } = e.target;
    setFormDataEdit(prev => ({ ...prev, [name]: value }));
  };

  const handleMemoryOptionChangeEdit = (index, field, value) => {
    const updated = [...formDataEdit.memoryOptions];
    updated[index] = { ...updated[index], [field]: value };
    setFormDataEdit(prev => ({ ...prev, memoryOptions: updated }));
  };

  const handleColorChangeEdit = (memoryIndex, colorIndex, field, value) => {
    const updated = [...formDataEdit.memoryOptions];
    const updatedColors = [...updated[memoryIndex].colors];
    updatedColors[colorIndex] = {
      ...updatedColors[colorIndex],
      [field]: value
    };
    updated[memoryIndex].colors = updatedColors;
    setFormDataEdit(prev => ({ ...prev, memoryOptions: updated }));
  };

  const addColorToMemoryEdit = (memoryIndex) => {
    const updated = [...formDataEdit.memoryOptions];
    updated[memoryIndex].colors.push({ color: '', bitrixId: '' });
    setFormDataEdit(prev => ({ ...prev, memoryOptions: updated }));
  };

  const removeColorFromMemoryEdit = (memoryIndex, colorIndex) => {
    const updated = [...formDataEdit.memoryOptions];
    updated[memoryIndex].colors = updated[memoryIndex].colors.filter((_, i) => i !== colorIndex);
    setFormDataEdit(prev => ({ ...prev, memoryOptions: updated }));
  };

  const addMemoryOptionEdit = () => {
    setFormDataEdit(prev => ({
      ...prev,
      memoryOptions: [
        ...prev.memoryOptions,
        { memory: '', colors: [''], price: '', discountedPrice: '' }
      ]
    }));
  };

  const removeMemoryOptionEdit = (index) => {
    const updated = formDataEdit.memoryOptions.filter((_, i) => i !== index);
    setFormDataEdit(prev => ({ ...prev, memoryOptions: updated }));
  };

  const handlePhotosEdit = (e) => {
    const files = Array.from(e.target.files);
    const newPhotos = files.map(file => ({
      file,
      preview: URL.createObjectURL(file)
    }));
    setPhotosEdit(prev => [...prev, ...newPhotos]);
  };

  const removeEditedPhoto = async (index) => {
    const photo = photosEdited[index];

    // Only delete from Yandex if it's a URL string (existing image)
    if (typeof photo === 'string') {
      try {
        await axios.post('https://nts-center.ru/api/delete-from-yandex', {
          url: photo,
        });
      } catch (err) {
        console.error('Failed to delete from Yandex:', err);
        alert('Ошибка при удалении изображения с сервера');
      }
    }

    setPhotosEdit(prev => prev.filter((_, i) => i !== index));
  };

  const removeNewPhoto = (index) => {
    setPhotos(prev => prev.filter((_, i) => i !== index));
  };

  const handleVideoEdit = (e) => {
    setVideoEdit(e.target.files[0]);
  };

  // ========== FORM SUBMISSION ==========
  const handleSubmit = async (e, isEdit = false) => {
    e.preventDefault();
    let productId;

    if (isEdit && selectedProduct?.product_id) {
      // Reuse existing product_id
      productId = selectedProduct.product_id;
    } else {
      // Generate new product_id based on existing products
      console.log("Fetched products:", products);
      console.log("Mapped product_ids:", products.map(p => p.product_Id));
      const productIds = products.map(p => p.product_id).filter(Number);
      productId = productIds.length > 0 ? Math.max(...productIds) + 1 : 1;
      console.log("🚀 ~ handleSubmit ~ productId:", productId)
    }
    try {
      // const uploadToBackendCDN = async (file) => {
      //   const formData = new FormData();
      //   formData.append('file', file);

      //   const res = await fetch('https://nts-center.ru/api/upload-to-yandex', {
      //     method: 'POST',
      //     body: formData,
      //   });

      //   const data = await res.json();
      //   if (!res.ok || data.error) throw new Error(data.error || 'Upload failed');
      //   return data.url;
      // };
      const uploadToBackendCDN = async (file, folder) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('folder', folder); // 💡 Add folder name

        const res = await fetch('https://nts-center.ru/api/upload-to-yandex', {
          method: 'POST',
          body: formData,
        });

        const data = await res.json();
        if (!res.ok || data.error) throw new Error(data.error || 'Upload failed');
        return data.url;
      };

      const finalForm = new FormData();
      const currentForm = isEdit ? formDataEdit : formData;

      // Add basic fields
      finalForm.append('name', currentForm.name);
      finalForm.append('brand', currentForm.brand);
      finalForm.append('model', currentForm.model);
      finalForm.append('description', currentForm.description);
      finalForm.append('product_id', productId);
      finalForm.append('showInShop', currentForm.showInShop);

      // Add memory options as JSON
      currentForm.memoryOptions.forEach(option => {
        finalForm.append('memoryOptions', JSON.stringify(option));
      });

      // Handle file uploads
      let uploadedPhotoUrls = [];
      let uploadedVideoUrl = null;

      const filesToUpload = isEdit
        ? photosEdited
          .map(photo => typeof photo === 'string' ? photo : photo.file)
          .filter(Boolean) // ✅ remove undefined
        : photos.map(p => p.file);

      if (filesToUpload.length > 0) {
        uploadedPhotoUrls = [];

        for (const file of filesToUpload) {
          // Only try uploading if it's a real File object
          if (file instanceof File) {
            const url = await uploadToBackendCDN(file, `phones/${productId}/`);
            uploadedPhotoUrls.push(url);
          } else if (typeof file === 'string') {
            // If it's already a URL (existing photo), reuse it
            uploadedPhotoUrls.push(file);
          }
        }
      }


      const videoToUpload = isEdit ? videoEdited : video;
      if (videoToUpload) {
        uploadedVideoUrl = await uploadToBackendCDN(videoToUpload, `phones/${productId}/`);
      }

      // Add media URLs
      uploadedPhotoUrls.forEach(url => finalForm.append('photos', url));
      if (uploadedVideoUrl) {
        finalForm.append('video', uploadedVideoUrl);
      }

      // Make API request
      if (isEdit && selectedProduct?.id) {
        await axios.put(`https://nts-center.ru/api/phones/${selectedProduct.id}`, finalForm, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        alert('Product updated successfully!');
        setIsModalOpen(false);
      } else {
        await axios.post('https://nts-center.ru/api/phones', finalForm, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        alert('Phone added successfully!');
      }

      // Reset form and refresh product list
      if (!isEdit) {
        setFormData({
          name: '',
          brand: '',
          model: '',
          description: '',
          memoryOptions: [{
            memory: '',
            colors: [''],
            price: '',
            discountedPrice: ''
          }]
        });
        setPhotos([]);
        setVideo(null);
      }
      fetchProducts();
    } catch (err) {
      console.error('Upload/Submit Error:', err);
      alert(`Error submitting form: ${err.message}`);
    }
  };
  const movePhoto = (index, direction) => {
    const newPhotos = [...photos];
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= newPhotos.length) return;
    [newPhotos[index], newPhotos[targetIndex]] = [newPhotos[targetIndex], newPhotos[index]];
    setPhotos(newPhotos);
  };
  const moveEditedPhoto = (index, direction) => {
    const newPhotos = [...photosEdited];
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= newPhotos.length) return;
    [newPhotos[index], newPhotos[targetIndex]] = [newPhotos[targetIndex], newPhotos[index]];
    setPhotosEdit(newPhotos);
  };

  const handleDeleteProduct = async () => {
    if (!selectedProduct) return;

    const confirmDelete = window.confirm("Are you sure you want to delete this product?");
    if (!confirmDelete) return;

    try {
      // 1. Delete associated photos
      if (selectedProduct.photos?.length) {
        for (const url of selectedProduct.photos) {
          await axios.post('https://nts-center.ru/api/delete-from-yandex', { url });
        }
      }

      // 2. Delete associated video
      if (selectedProduct.video) {
        await axios.post('https://nts-center.ru/api/delete-from-yandex', { url: selectedProduct.video });
      }

      // 3. Delete the product from DB
      await axios.delete(`https://nts-center.ru/api/phones/${selectedProduct.id}`);

      alert("Product deleted successfully.");
      setIsModalOpen(false);
      fetchProducts(); // Refresh product list
    } catch (err) {
      console.error("Failed to delete product:", err);
      alert("Failed to delete product.");
    }
  };

  return (
    <div className="phone-form-container">
      {/* Main Add Product Form */}
      <form onSubmit={(e) => handleSubmit(e, false)} className="phone-form">
        <h2>Добавить новый телефон</h2>

        {/* Basic Information */}
        <div className="form-section">
          {/* <h3>Basic Information</h3> */}
          <div className="form-group">
            <label>Название:</label>
            <input
              name="name"
              placeholder="Смартфон Apple iPhone 15 Pro"
              value={formData.name}
              onChange={handleChange}
              className="form-input"
              required
            />
          </div>

          <div className="form-group">
            <label>Бренд:</label>
            <input
              name="brand"
              placeholder="Apple"
              value={formData.brand}
              onChange={handleChange}
              className="form-input"
              required
            />
          </div>

          <div className="form-group">
            <label>Модель:</label>
            <input
              name="model"
              placeholder="Iphone 15 Pro"
              value={formData.model}
              onChange={handleChange}
              className="form-input"
              required
            />
          </div>

          <div className="form-group">
            <label>Описание:</label>
            <textarea
              name="description"
              placeholder="Product description..."
              value={formData.description}
              onChange={handleChange}
              className="form-input"
              rows="4"
            />
          </div>
        </div>

        {/* Memory Options */}
        <div className="form-section">
          <h3>Память</h3>
          {formData.memoryOptions.map((option, memoryIndex) => (
            <div key={memoryIndex} className="memory-option-group">
              <div className="memory-option-header">
                <h4>Опция {memoryIndex + 1}</h4>
                {formData.memoryOptions.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeMemoryOption(memoryIndex)}
                    className="btn btn-danger"
                  >
                    Удалить опцию
                  </button>
                )}
              </div>

              <div className="form-group">
                <label>Память:</label>
                <input
                  value={option.memory}
                  onChange={(e) => handleMemoryOptionChange(memoryIndex, 'memory', e.target.value)}
                  className="form-input"
                  placeholder="128 ГБ"
                  required
                />
              </div>

              <div className="form-group">
                <label>Цена (₽):</label>
                <input
                  type="number"
                  value={option.price}
                  onChange={(e) => handleMemoryOptionChange(memoryIndex, 'price', e.target.value)}
                  className="form-input"
                  required
                />
              </div>

              <div className="form-group">
                <label>Цена со скидкой (₽):</label>
                <input
                  type="number"
                  value={option.discountedPrice}
                  onChange={(e) => handleMemoryOptionChange(memoryIndex, 'discountedPrice', e.target.value)}
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label>Цвета:</label>
                {option.colors.map((colorObj, colorIndex) => (
                  <div key={colorIndex} className="color-input-group">
                    <input
                      value={colorObj.color}
                      onChange={(e) =>
                        handleColorChange(memoryIndex, colorIndex, 'color', e.target.value)
                      }
                      className="form-input"
                      placeholder="Цвет"
                      required
                    />
                    <input
                      type="number"
                      value={colorObj.bitrixId}
                      onChange={(e) =>
                        handleColorChange(memoryIndex, colorIndex, 'bitrixId', e.target.value)
                      }
                      className="form-input"
                      placeholder="Bitrix ID"
                    />
                    <button
                      type="button"
                      onClick={() => removeColorFromMemory(memoryIndex, colorIndex)}
                      className="btn btn-danger"
                      disabled={option.colors.length === 1}
                    >
                      ×
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={() => addColorToMemory(memoryIndex)}
                  className="btn btn-secondary"
                >
                  + Добавить цвет
                </button>
              </div>
            </div>
          ))}

          <button
            type="button"
            onClick={addMemoryOption}
            className="btn btn-primary add-memory-btn"
          >
            + Добавить опцию памяти
          </button>
        </div>
        <div className="form-group">
          <label className="toggle-container">
            <input
              type="checkbox"
              checked={formData.showInShop}
              onChange={(e) => {
                const checked = e.target.checked;
                setFormData(prev => ({ ...prev, showInShop: checked }));
              }}
            />
            <span className="toggle-switch" />
            <span className="toggle-label-text">Показывать в магазине</span>
          </label>
        </div>


        {/* Media Uploads */}
        <div className="form-section">
          <h3>Медия</h3>
          <div className="form-group">
            <label>Картинки:</label>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handlePhotosChange}
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label>Сортировать:</label>
            <div className="thumbnail-preview">
              {photos.map((photo, index) => (
                <div key={index} className="thumbnail-wrapper">
                  <img src={photo.preview} className="thumbnail-img" alt={`photo-${index}`} />
                  <div className="thumbnail-controls">
                    <button
                      type="button"
                      onClick={() => movePhoto(index, -1)}
                      disabled={index === 0}
                    >↑</button>
                    <button
                      type="button"
                      onClick={() => movePhoto(index, 1)}
                      disabled={index === photos.length - 1}
                    >↓</button>
                    {/* ✅ Add this: */}
                    <button
                      type="button"
                      className="remove-thumbnail-btn"
                      onClick={() => removeNewPhoto(index)}
                      title="Remove"
                    >×</button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label>Видео:</label>
            <input
              type="file"
              accept="video/*"
              onChange={handleVideoChange}
              className="form-input"
            />
          </div>
        </div>

        <button type="submit" className="btn btn-submit">Добавить продукт</button>
      </form>

      {/* Product List */}
      <div className="product-list-container">
        <h2>Все продукты</h2>
        <div className="product-list">
          {products.length > 0 ? (
            products.map((product) => (
              <div
                key={product._id || product.id}
                className="product-card"
                // onClick={() => {
                //   setSelectedProduct(product);
                //   // Transform product data to match our form structure
                //   const transformedData = {
                //     name: product.name || '',
                //     brand: product.brand || '',
                //     model: product.model || '',
                //     description: product.description || '',
                //     showInShop: product.showInShop !== false,
                //     memoryOptions: product.memoryOptions || [{
                //       memory: '',
                //       colors: [''],
                //       price: '',
                //       discountedPrice: ''
                //     }]
                //   };
                //   setFormDataEdit(transformedData);
                //   setPhotosEdit(product.photos || []);
                //   setIsModalOpen(true);
                // }}
                onClick={async () => {
                  const freshProduct = await axios.get(`https://nts-center.ru/api/phones/${product.id}`);
                  const updatedProduct = freshProduct.data;
                  // if(updatedProduct.showInShop == 'undefined'){
                  //   updatedProduct.showInShop = false
                  // }
                  setSelectedProduct(updatedProduct);
                  setFormDataEdit({
                    name: updatedProduct.name || '',
                    brand: updatedProduct.brand || '',
                    model: updatedProduct.model || '',
                    description: updatedProduct.description || '',
                    // showInShop: updatedProduct.showInShop,
                    showInShop: product.showInShop !== false,
                    memoryOptions: updatedProduct.memoryOptions || [{
                      memory: '',
                      colors: [''],
                      price: '',
                      discountedPrice: ''
                    }]
                  });
                  setPhotosEdit(updatedProduct.photos || []);
                  setIsModalOpen(true);
                }}
              >
                <div className="product-card-header">
                  <h3>{product.name}</h3>
                  <p className="product-model">{product.brand} {product.model}</p>
                </div>

                {/* {product.photos?.[0] && (
                  <div className="product-image">
                    <img src={product.photos[0]} alt={product.name} />
                  </div>
                )} */}

                <div className="product-specs">
                  {product.memoryOptions?.map((option, idx) => (
                    <div key={idx} className="memory-option">
                      <div className="memory-size">{option.memory}</div>
                      <div className="price-block">
                        {option.discountedPrice ? (
                          <>
                            <span className="price-discounted">{option.discountedPrice.toLocaleString()} ₽</span>&nbsp;&nbsp;
                            <span className="price-original">{option.price.toLocaleString()} ₽</span>
                          </>
                        ) : (
                          <span className="price-regular">{option.price.toLocaleString()} ₽</span>
                        )}
                      </div>

                      {/* {option.colors?.length > 0 && (
                        <div className="colors-list">
                          <div className="color-dots">
                            {option.colors.map((color, colorIdx) => (
                              <span
                                key={colorIdx}
                                className="color-dot"
                                title={color}
                              />
                            ))}
                          </div>
                        </div>
                      )} */}
                    </div>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <p className="no-products">No products found. Add your first product above.</p>
          )}
        </div>
      </div>

      {/* Edit Modal */}
      {isModalOpen && (
        <div className="modal-backdrop">
          <div className="modal">
            <div className="modal-header">
              <h3>Edit Product</h3>
              <button
                className="modal-close"
                onClick={() => setIsModalOpen(false)}
              >
                &times;
              </button>
            </div>

            <form onSubmit={(e) => handleSubmit(e, true)} className="edit-form">
              {/* Basic Information */}
              <div className="form-section">
                {/* <h4>Basic Information</h4> */}
                <div className="form-group">
                  <label>Название:</label>
                  <input
                    name="name"
                    value={formDataEdit.name}
                    onChange={handleChangeEdit}
                    className="form-input"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Бренд:</label>
                  <input
                    name="brand"
                    value={formDataEdit.brand}
                    onChange={handleChangeEdit}
                    className="form-input"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Модель:</label>
                  <input
                    name="model"
                    value={formDataEdit.model}
                    onChange={handleChangeEdit}
                    className="form-input"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Описание:</label>
                  <textarea
                    name="description"
                    value={formDataEdit.description}
                    onChange={handleChangeEdit}
                    className="form-input"
                    rows="4"
                  />
                </div>
              </div>

              {/* Memory Options */}
              <div className="form-section">
                <h4>Память</h4>
                {formDataEdit.memoryOptions.map((option, memoryIndex) => (
                  <div key={memoryIndex} className="memory-option-group">
                    <div className="memory-option-header">
                      <h5>Опция {memoryIndex + 1}</h5>
                      {formDataEdit.memoryOptions.length > 1 && (
                        <button
                          type="button"
                          onClick={() => removeMemoryOptionEdit(memoryIndex)}
                          className="btn btn-danger"
                        >
                          Удалить опцию
                        </button>
                      )}
                    </div>

                    <div className="form-group">
                      <label>Память:</label>
                      <input
                        value={option.memory}
                        onChange={(e) => handleMemoryOptionChangeEdit(memoryIndex, 'memory', e.target.value)}
                        className="form-input"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>Цена (₽):</label>
                      <input
                        type="number"
                        value={option.price}
                        onChange={(e) => handleMemoryOptionChangeEdit(memoryIndex, 'price', e.target.value)}
                        className="form-input"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>Цена со скидкой (₽):</label>
                      <input
                        type="number"
                        value={option.discountedPrice}
                        onChange={(e) => handleMemoryOptionChangeEdit(memoryIndex, 'discountedPrice', e.target.value)}
                        className="form-input"
                      />
                    </div>

                    <div className="form-group">
                      <label>Цвета:</label>
                      {option.colors.map((colorObj, colorIndex) => (
                        <div key={colorIndex} className="color-input-group">
                          <input
                            value={colorObj.color}
                            onChange={(e) =>
                              handleColorChangeEdit(memoryIndex, colorIndex, 'color', e.target.value)
                            }
                            className="form-input"
                            placeholder="Цвет"
                            required
                          />
                          <input
                            type="number"
                            value={colorObj.bitrixId}
                            onChange={(e) =>
                              handleColorChangeEdit(memoryIndex, colorIndex, 'bitrixId', e.target.value)
                            }
                            className="form-input"
                            placeholder="Bitrix ID"
                          />
                          <button
                            type="button"
                            onClick={() => removeColorFromMemoryEdit(memoryIndex, colorIndex)}
                            className="btn btn-danger"
                            disabled={option.colors.length === 1}
                          >
                            ×
                          </button>
                        </div>
                      ))}

                      <button
                        type="button"
                        onClick={() => addColorToMemoryEdit(memoryIndex)}
                        className="btn btn-secondary"
                      >
                        + Добавить цвет
                      </button>
                    </div>
                  </div>
                ))}

                <button
                  type="button"
                  onClick={addMemoryOptionEdit}
                  className="btn btn-primary add-memory-btn"
                >
                  + Добавить опцию памяти
                </button>
              </div>
              <div className="form-group">
                <label className="toggle-container">
                  <input
                    type="checkbox"
                    checked={formDataEdit.showInShop}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setFormDataEdit(prev => ({ ...prev, showInShop: checked }));
                    }}
                  />
                  <span className="toggle-switch" />
                  <span className="toggle-label-text">Показывать в магазине</span>
                </label>
              </div>
              <div className="form-section">
                <h4>Медия</h4>
                <div className="form-group">
                  <label>Картинки:</label>
                  <div className="thumbnail-preview">
                    {photosEdited.map((photo, idx) => (
                      <div key={idx} className="thumbnail-wrapper">
                        <img
                          src={typeof photo === 'string' ? photo : photo.preview}
                          alt={`photo-${idx}`}
                          className="thumbnail-img"
                        />
                        <div className="thumbnail-controls">
                          <button
                            type="button"
                            onClick={() => moveEditedPhoto(idx, -1)}
                            disabled={idx === 0}
                          >
                            ↑
                          </button>
                          <button
                            type="button"
                            onClick={() => moveEditedPhoto(idx, 1)}
                            disabled={idx === photosEdited.length - 1}
                          >
                            ↓
                          </button>
                          <button
                            type="button"
                            className="remove-thumbnail-btn"
                            onClick={() => removeEditedPhoto(idx)}
                            title="Remove"
                          >
                            ×
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>


                <div className="form-group">
                  <label>Новые картинки:</label>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handlePhotosEdit}
                    className="form-input"
                  />
                </div>


                <div className="form-group">
                  <label>Новое видео:</label>
                  <input
                    type="file"
                    accept="video/*"
                    onChange={handleVideoEdit}
                    className="form-input"
                  />
                </div>
              </div>

              <div className="modal-actions">
                <button type="submit" className="btn btn-submit">Сохранить</button>
                <button
                  type="button"
                  className="btn btn-cancel"
                  onClick={() => setIsModalOpen(false)}
                >
                  Отменить
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleDeleteProduct}
                >
                  Удалить
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}